export default "__VITE_ASSET__OBUsDkZC__"